

















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { projectDefaultColor } from '@/services/utils.service';

@Component
export default class Checkbox extends Vue {
  @Prop({ required: true }) readonly data!: Record<string, any>;
  @Prop({ required: false }) readonly parent!: Record<string, any>;
  @Prop({ required: false }) readonly closeOpenSubCategories!: (type: string) => void;
  projectDefaultColor = projectDefaultColor();

  @Emit()
  change(value: boolean) {
    this.data.selected = value;
    if (this.data.type === 'INTERNET4G&5G') {
      if (value) {
        this.data.subCat[0].selected = value;
      } else {
        this.data.subCat.forEach((el: Record<string, any>) => {
          el.selected = false;
        });
      }
      this.openSubcategories(this.data.type);
    } else if (this.data.subCat) {
      this.data.subCat.forEach((el: Record<string, any>) => {
        el.selected = value;
      });
      this.openSubcategories(this.data.type);
    } else if (this.parent) {
      this.parent.selected = this.parent.subCat.find((el: Record<string, any>) => el.selected);
      if (!this.parent.subCat.find((el: Record<string, any>) => el.selected)) this.openSubcategories(this.data.type);
    }
    return { value, type: this.data.type };
  }
  openSubcategories(type: string) {
    if (type) {
      if (this.data.subCat) {
        this.closeOpenSubCategories(type);
      } else if (this.parent) {
        this.closeOpenSubCategories(this.parent.type);
      }
    }
  }
}
